import { render, staticRenderFns } from "./FaqCard.vue?vue&type=template&id=ba5d673e&"
import script from "./FaqCard.vue?vue&type=script&lang=ts&"
export * from "./FaqCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FCFaqCard: require('/opt/build/repo/apps/shop/components/FCFaqCard.vue').default})
